import { useEffect, useMemo, useState } from "react";
import { DocumentContentActions, DocumentHeader } from "../../documentsApi";
import { useAppDispatch } from "../../../../app/hooks";
import { DocumentTest, loadDocumentAllTests } from "../../documentTests/documentTestsApi";
import { unwrapResult } from "@reduxjs/toolkit";
import { LoadingContainer } from "../../../../app/LoadingContainer";
import { ErrorContainer } from "../../../../app/ErrorContainer";
import { PrintPreviewDocumentTestMethodologyView } from "./PrintPreviewDocumentTestMethodologyView";

export interface DocumentScheduleTestSectionViewProps {
    document: DocumentHeader
}

export const DocumentTestMethodologySectionView = ({ document }: DocumentScheduleTestSectionViewProps) => {
    const dispatch = useAppDispatch()

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [error, setError] = useState(null);
    const [documentTests, setDocumentTests] = useState<DocumentTest[]>([]);


    const rows = useMemo(
        () => {
            const arr = [...documentTests];
            arr.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
            return arr;
        },
        [documentTests]
    );

    useEffect(() => {
        setIsLoading(true)
        dispatch(loadDocumentAllTests({ documentId: Number(document.id) }))
            .then(unwrapResult)
            .then((versions: DocumentTest[]) => {
                setDocumentTests(versions);
            })
            .catch((error) => { console.error(error); setIsError(true); setError(error); })
            .finally(() => setIsLoading(false))
    }, [document, dispatch])

    // ======================================================
    //  Render
    // ======================================================
    if (isError) {
        return <>
            <ErrorContainer error={error} />
        </>
    }

    if (isLoading) {
        return <>
            <LoadingContainer />
        </>
    }

    return (
        <>
            <PrintPreviewDocumentTestMethodologyView tests={rows} lang={document.language} />
        </>
    );
};

